module.exports = __webpack_public_path__ + "static/media/SceneThumb@1x.b6685999.png";